import { Yup, type YupTypes } from "@pharmupp/p3-front-commons"
import { getRequiredUserSchema } from "@pharmupp/p3-user-domain"

export enum CreateAdhModalFields {
  PRIMARY_HOLDER = "primaryHolder",
  PHARMACY = "pharmacy",
  CIP_CODE = "cipCode",
  CERP_CODE = "cerpCode",
  UPP_ID = "uppId",
  SECTOR_ID = "sectorId",
  CERP_BRANCH = "cerpBranch",
  ENTRY_DATE = "entryDate",
}

export const schema = Yup.object({
  [CreateAdhModalFields.PRIMARY_HOLDER]: getRequiredUserSchema("Titulaire requis"),
  [CreateAdhModalFields.PHARMACY]: Yup.string().required(),
  [CreateAdhModalFields.CIP_CODE]: Yup.number().required().min(2000000).max(2999999),
  [CreateAdhModalFields.CERP_CODE]: Yup.string()
    .required()
    // Yup.string().length(5) does not work on numbers
    .matches(/^\d{5}$/, "Le champ doit comporter 5 chiffres"),
  [CreateAdhModalFields.UPP_ID]: Yup.number().required(),
  [CreateAdhModalFields.SECTOR_ID]: Yup.number().required(),
  [CreateAdhModalFields.CERP_BRANCH]: Yup.object({
    code: Yup.string().required("L'établissement CERP est requis"),
  }).required("L'établissement CERP est requis"),
  [CreateAdhModalFields.ENTRY_DATE]: Yup.date().required(
    "La date d'ancienneté est requise",
  ),
}).required()

export type CreateAdhFormValues = YupTypes.InferType<typeof schema>
